export default function ScoreGauge({ score = 0, size = 220, accent = "#002FA7" }) {
  const radius = 90;
  const stroke = 14;
  const normalizedRadius = radius - stroke / 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const offset = circumference - (Math.max(0, Math.min(100, score)) / 100) * circumference;

  let label = "Zwak";
  if (score >= 80) label = "Sterk";
  else if (score >= 60) label = "Gemiddeld";
  else if (score >= 40) label = "Risicovol";

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }} data-testid="score-gauge">
      <svg width={size} height={size} viewBox="0 0 200 200" className="rotate-[-90deg]">
        <circle
          cx="100"
          cy="100"
          r={normalizedRadius}
          stroke="#E2E8F0"
          strokeWidth={stroke}
          fill="transparent"
        />
        <circle
          cx="100"
          cy="100"
          r={normalizedRadius}
          stroke={accent}
          strokeWidth={stroke}
          strokeLinecap="round"
          fill="transparent"
          style={{
            strokeDasharray: circumference,
            strokeDashoffset: offset,
            transition: "stroke-dashoffset 1s ease-out",
          }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-display text-5xl font-bold text-ink leading-none" data-testid="score-value">
          {score}
        </span>
        <span className="text-xs text-ink-soft uppercase tracking-wider mt-1">van 100</span>
        <span
          className="mt-2 text-xs font-semibold px-2 py-0.5 rounded-full"
          style={{ background: `${accent}14`, color: accent }}
        >
          {label}
        </span>
      </div>
    </div>
  );
}
